import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAkT6UNxKTuI8CX5P7n-FoDuP9iiLA_QGc",
  authDomain: "hallgord-bb006.firebaseapp.com",
  projectId: "hallgord-bb006",
  storageBucket: "hallgord-bb006.appspot.com",
  messagingSenderId: "856612651987",
  appId: "1:856612651987:web:9f5536500c08ddf6b7a526"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };
export const db = getFirestore(app);
